import { render, staticRenderFns } from "./detail2.vue?vue&type=template&id=195f65e9&scoped=true&lang=pug&"
import script from "./detail2.vue?vue&type=script&lang=js&"
export * from "./detail2.vue?vue&type=script&lang=js&"
import style0 from "./detail2.vue?vue&type=style&index=0&id=195f65e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195f65e9",
  null
  
)

component.options.__file = "detail2.vue"
export default component.exports